import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useProjectGiveMultipleChoiceAnswersFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Answers/hooks/giveMultipleChoiceAnswers/useProjectGiveMultipleChoiceAnswersFunction';
import useTemplateGiveMultipleChoiceAnswersFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Answers/hooks/giveMultipleChoiceAnswers/useTemplateGiveMultipleChoiceAnswersFunction';

const useGiveMultipleChoiceAnswersFunction = (questionId, isCustomQuestion) => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useProjectGiveMultipleChoiceAnswersFunction(
        questionId,
        isCustomQuestion,
    );

    const dataFromTemplate = useTemplateGiveMultipleChoiceAnswersFunction(
        questionId,
        isCustomQuestion,
    );

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return {};
};

export default useGiveMultipleChoiceAnswersFunction;
